/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Button, Form, Input, message, Modal, Radio } from "antd";
import _ from "lodash";
import React, { useCallback, useState } from "react";
import { useFormatMessage } from "src/hooks";
import messageIds from "src/locales/messageIds";
import { AiServiceClient } from "src/services/AIPlatformService";

export default React.memo(
  (props: { isModalShow: boolean; onShow: () => void; fetch: () => void }) => {
    const { isModalShow, onShow, fetch } = props;
    const formatMessage = useFormatMessage();
    const [form] = Form.useForm();
    const [status, setStatus] = useState(1);
    const [accountType, setAccountType] = useState(0);

    const onCancel = useCallback(() => {
      if (isModalShow) {
        onShow();
        form.resetFields();
        setStatus(1);
        setAccountType(0);
      }
    }, [isModalShow, form, onShow]);

    const onCreate = useCallback(async () => {
      const formContent = await form.validateFields();
      const trimEmail = {
        email: _.trim(formContent.email),
      };
      Object.assign(formContent, trimEmail);
      AiServiceClient.addUser(formContent).then((res) => {
        if (res.data.success) {
          fetch();
          message.success(formatMessage(messageIds.common.createSuccessfully));
        } else {
          message.error(
            `${formatMessage(messageIds.common.createFailed)}, ${
              res.data.message
            }`
          );
        }
      });
      onCancel();
    }, [form, onCancel, fetch, formatMessage]);

    // const onValidateEmail = useCallback(
    //   (rule, value) => {
    //     const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    //     if (value && pattern.test(_.trim(value))) {
    //       return Promise.resolve();
    //     } else {
    //       return Promise.reject(
    //         formatMessage(messageIds.aiManage.userManagment.validate.email)
    //       );
    //     }
    //   },
    //   [formatMessage]
    // );

    return (
      <Modal
        title={formatMessage(messageIds.common.create)}
        visible={isModalShow}
        footer={""}
        onCancel={onCancel}
        css={css`
          .ant-modal-content {
            width: 32vw;
          }
          .ant-modal-header {
            border-bottom: none;
          }
        `}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label={formatMessage(
              messageIds.aiManage.userManagment.ssoIdentityUid
            )}
            name="ssoIdentityUid"
            rules={[
              {
                required: true,
                message: formatMessage(
                  messageIds.aiManage.userManagment.validate.inputSsoId
                ),
              },
              {
                whitespace: true,
              },
            ]}
          >
            <Input
              placeholder={formatMessage(messageIds.common.placeholder)}
            ></Input>
          </Form.Item>
          <Form.Item
            label={formatMessage(messageIds.common.name)}
            name="name"
            rules={[
              {
                required: true,
                message: formatMessage(
                  messageIds.aiManage.userManagment.validate.inputName
                ),
              },
              {
                whitespace: true,
              },
            ]}
          >
            <Input
              placeholder={formatMessage(messageIds.common.placeholder)}
            ></Input>
          </Form.Item>
          <Form.Item
            label={formatMessage(messageIds.common.email)}
            name="email"
          >
            <Input
              placeholder={formatMessage(messageIds.common.placeholder)}
            ></Input>
          </Form.Item>
          <Form.Item
            label={formatMessage(messageIds.common.phone)}
            name="phone"
          >
            <Input
              placeholder={formatMessage(messageIds.common.placeholder)}
            ></Input>
          </Form.Item>
          <Form.Item
            label={formatMessage(messageIds.aiManage.userManagment.status)}
            name="status"
            rules={[
              {
                required: true,
                message: formatMessage(
                  messageIds.aiManage.userManagment.validate.selectStatus
                ),
              },
            ]}
            initialValue={status}
          >
            <Radio.Group onChange={(e) => setStatus(e.target.value)} disabled>
              <Radio value={1}>
                {formatMessage(messageIds.aiManage.userManagment.enable)}
              </Radio>
              <Radio value={0}>
                {formatMessage(messageIds.aiManage.userManagment.disable)}
              </Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label={formatMessage(messageIds.aiManage.userManagment.accountType)}
            name="accountType"
            rules={[
              {
                required: true,
                message: formatMessage(
                  messageIds.aiManage.userManagment.validate.selectAccountType
                ),
              },
            ]}
            initialValue={accountType}
          >
            <Radio.Group
              onChange={(e) => setAccountType(e.target.value)}
              disabled
            >
              <Radio value={0}>
                {formatMessage(messageIds.aiManage.userManagment.prepaid)}
              </Radio>
              <Radio value={1}>
                {formatMessage(messageIds.aiManage.userManagment.noprepaid)}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
        <div
          css={css`
            text-align: right;
            padding-top: 16px;
            padding-bottom: 16px;
          `}
        >
          <Button
            css={css`
              margin-right: 16px;
            `}
            onClick={onCancel}
          >
            {formatMessage(messageIds.common.cancel)}
          </Button>
          <Button type="primary" onClick={onCreate}>
            {formatMessage(messageIds.common.create)}
          </Button>
        </div>
      </Modal>
    );
  }
);
